/**
 * @file SurfaceFillField.tsx
 * @description Заливка поверхности — ролью цвета темы или своим цветом
 * (phase19.16, решение пользователя 2026-10-11 — дополнение SB8; SB120 —
 * свобода выбора, предупреждения вместо запретов). Одно поле для шапки,
 * подвала и фона секции.
 *
 * Тонкая обёртка над общим полем `ColorField mode="fill"`
 * (uiux-sb120-fields §3): роли `SITE_FILL_ROLES` (подписи — реестром) и
 * «Свой цвет»; под полем — контраст текста на заливке с числом, слабый —
 * предупреждение, выбор не запрещается. Вместе с заливкой отдаётся тон
 * поверхности — его пишут в `header.tone`/`footer.tone`. Подпись поля —
 * у группы настроек, над сеткой не повторяется.
 */

import { SITE_FILL_ROLES, type SiteColors, type SiteFillRole, type SiteSurfaceFill, type SiteSurfaceTone } from "@chaiberi/shared";

import { ColorField } from "../site-fields/ColorField";
import { FILL_ROLE_LABELS } from "../../lib/site-view/surface-fill-labels";

interface Props {
  label: string;
  value: SiteSurfaceFill;
  colors: SiteColors;
  onChange: (fill: SiteSurfaceFill, tone: SiteSurfaceTone) => void;
  labels?: Readonly<Record<SiteFillRole, string>>;
}

export function SurfaceFillField({ label, value, colors, onChange, labels = FILL_ROLE_LABELS }: Props) {
  return (
    <ColorField
      mode="fill"
      label={label}
      hideLabel
      value={value}
      roles={SITE_FILL_ROLES}
      labels={labels}
      colors={colors}
      // Ячейки «Без фона» здесь нет — пустой заливки не бывает.
      onChange={(fill, tone) => (fill && tone ? onChange(fill, tone) : undefined)}
    />
  );
}
